import { Injectable } from '@angular/core';
import { Failure, Response, Success } from '@sdk/sdk';
import { AuthRepository } from '../repositories/auth.repository';

export class ValidateSSOOrganizationError extends Error {}

@Injectable({ providedIn: 'root' })
export class ValidateSSOOrganizationUseCase {
  constructor(private _repository: AuthRepository) {}

  async execute(name: string): Promise<Response<boolean, ValidateSSOOrganizationError>> {
    const result = await this._repository.validateSSOOrganization(name);
    if (result instanceof Failure) {
      return new Failure(new ValidateSSOOrganizationError());
    }
    return new Success(true);
  }
}
